<script lang="jsx">
import mixin from '@/plans/mx/shopping-cart';
import { AUDIO_SUB_TYPES } from '@/common/constants';
import ldkAudioMixins from './mixins/ldk-audio-mixins';
import { isDIDPlan } from '@/plans/TOLLFREE$DID/common';
import { isFromShoppingCart } from '@/views/config/shopping-cart/persist/plan-remove';
import { planUnitMap } from '@/common/product-unit';

export default {
  mixins: [mixin, ldkAudioMixins],
  name: 'AudioInCart',
  computed: {
    hideEditButton() {
      return this.$context.is.editPage || this.$context.is.addPage;
    },

    isShowRemove () {
      if(isFromShoppingCart()) {
        return true;
      }
      return !this.$context.is.editPage && !this.$context.is.addPage;
    },

    DIDPlans() {
      return this.getSelectedPlans.filter(isDIDPlan);
    },
    plans() {
      return [
        ...this.mx_plans.filter((p) => p.category === AUDIO_SUB_TYPES.UNLIMITED),
        ...this.mx_plans.filter((p) => p.category !== AUDIO_SUB_TYPES.UNLIMITED),
        ...this.DIDPlans,
      ];
    },
  },
  methods: {
    renderDIDPlan(plan) {
      return (
        <div class="opc-audio-cart__sub-project">
          {this.mx_subTitle(this.$t(plan.typeNameKey), this.mx_price(plan), plan?.plan_code)}
          {this.mx_discount(plan.plan_code)}
          {this.mx_cycle(plan.billing_cycle)}
          {this.mx_new_license({ ...plan, unit: planUnitMap.number }, plan.cartInfo.selected_number)}
          {!this.hideEditButton && this.mx_edit(plan)}
          {this.isShowRemove && this.mx_remove(plan)}
        </div>
      );
    },
    $renderPrice() {
      if (!this.plans.length) return;
      if (this.plans.length === 1) {
        const plan = this.plans[0];
        return (
          <div class="opc-cart-item">
            <div>
              {this.mx_title(
                this.$t(plan.typeNameKey || 'billing.tollfree.audio_conferencing.title'),
                this.mx_price(plan),
                plan?.plan_code,
                plan?.parent_category,
              )}
              {this.mx_discount(plan.plan_code)}
              {this.mx_cycle(plan.billing_cycle)}
              {plan.category === AUDIO_SUB_TYPES.TOLL_FREE
                ? null
                : this.mx_new_license({ ...plan, unit: planUnitMap.license }, plan.cartInfo.selected_number)}
              {!this.hideEditButton && this.mx_edit(plan)}
              {this.isShowRemove && this.mx_remove(plan)}
            </div>
          </div>
        );
      }
      return (
        <div class="opc-cart-item">
          {this.mx_main_title(
            this.$t('billing.tollfree.audio_conferencing.title'),
            undefined,
            this.plans[0]?.parent_category,
          )}
          {this.plans.map((plan) => {
            if (isDIDPlan(plan)) return this.renderDIDPlan(plan);
            return (
              <div class="opc-audio-cart__sub-project">
                {this.mx_subTitle(
                  `${this.$t(plan.typeNameKey)}`,
                  this.mx_price(plan),
                  plan?.plan_code,
                  plan?.parent_category,
                )}
                {this.mx_discount(plan.plan_code)}
                {this.mx_cycle(plan.billing_cycle)}
                {plan.category === AUDIO_SUB_TYPES.TOLL_FREE
                  ? null
                  : this.mx_new_license({ ...plan, unit: planUnitMap.license }, plan.cartInfo.selected_number)}
                {!this.hideEditButton && this.mx_edit(plan)}
                {this.isShowRemove && this.mx_remove(plan)}
              </div>
            );
          })}
        </div>
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.opc-audio-cart {
  &__sub-project {
    padding-bottom: 8px;
    &:last-child {
      padding-bottom: 0;
    }
  }
}
</style>
